export const AccountDetailState = Object.freeze({
	ACCOUNT_INFO: 0, // 회원정보 관리
	PAYMENT_INFO: 1, // 결제정보 관리
});

export const LoginScenarioState = Object.freeze({
	None: 0,
	LoginPopup: 1, // 로그인 창
	LoginRepasswordTelelphonePopup: 2, //로그인 전화번호 인증창
	LoginRepasswordPopup: 3, //비밀번호 재설정창
});

export const SecretNumberState = Object.freeze({
	None: 0,
	Confirm: 1,
	Change: 2,
});
